import { render } from "./StepperButton.vue?vue&type=template&id=4611fc66"
import script from "./StepperButton.vue?vue&type=script&lang=js"
export * from "./StepperButton.vue?vue&type=script&lang=js"
script.render = render

export default script